module.exports = __webpack_public_path__ + "img/information.f965d3a7.png";